<script>
  import Sidebar from '../../components/Sidebar.vue'
  import Topbar from '../../components/Topbar.vue'
  import services from '@/http'
  import toast from '@/methods/toast'
  import visualEffects from '@/methods/visualEffects'
  import messages from '@/methods/messages'

  export default {
      name: 'config',
      components: {
          Sidebar,
          Topbar
      },
      data () {
          return {
            form: {
              currentPass: '',
              password: '',
              confirmPass: ''
            }
          }
      },
      methods: {
          seePassword (idName) {
              visualEffects.seePassword(idName)
          },
          validData () {
            if (this.form.password !== this.form.confirmPass) {
              toast.toastError('As senhas não conhecidem!')
              return false              
            } else if (this.form.currentPass === '' || this.form.password === '' || this.form.confirmPass === '') {
              toast.toastError('Informe todos os campos antes de alterar!')
              return false
            } else {
              return true
            }
          },
          sendData () {
            if (this.validData()) {
              services.auth.changePassword(this.form)
              .then(() => {
                toast.toastSuccess('Senha alterada com sucesso!')
                this.$router.push({ name: 'home' })
              })
              .catch((res) => {
                let msg = messages.getMessage(res, 'Falha ao atualizar senha!')
                toast.toastError(msg)
              })
            }
          }
      }
  }
</script>

<template>
  <div class="">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <Topbar />
    <div id="wrapper">
      <Sidebar />
        <div class="card size-card mx-auto mt-5">
          <p class="card-header text-center bg-blue-dt">Alterar senha de usuário</p>

          <div class="card-body">
            <form @submit.prevent="sendData()">
              <div class="form-group">
                <div class="form-group">
                  <label for="pass">Senha atual</label>
                  <div class="input-group">                    
                    <input v-model="form.currentPass" type="password" class="form-control" id="currentPass" placeholder="Senha">
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="input-group-text"                        
                        v-on:click="seePassword('currentPass')"
                      >
                        <i id="icon-currentPass" class="fa fa-eye"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="pass">Nova Senha</label>
                  <div class="input-group">                    
                    <input v-model="form.password" type="password" class="form-control" id="pass" placeholder="Senha">
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="input-group-text"                        
                        v-on:click="seePassword('pass')"
                      >
                        <i id="icon-pass" class="fa fa-eye"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="pass">Confirmar Nova Senha</label>
                  <div class="input-group">                    
                    <input v-model="form.confirmPass" type="password" class="form-control" id="newPass" placeholder="Senha">
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="input-group-text"                        
                        v-on:click="seePassword('newPass')"
                      >
                        <i id="icon-newPass" class="fa fa-eye"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="m-0 p-0 card-body text-right">
                  <button type="submit" class="btn bg-blue-dt">Alterar</button>
                </div>
              </div>  
            </form>
          </div>    
      </div>
    </div>
  </div>
</template>

<style>
    .size-card{
      width: 90%;
      max-width: 400px
    }
</style>